import { html, css, LitElement } from 'lit';
import { NexusComponent } from "./nexus.component";

class StepperContainerComponent extends NexusComponent {

  static properties = {
    step: {
      type: Number,
      attribute: 'step',
      reflect: true,
    }
  };

  constructor() {
    super();
    this.step;
  }

  static get styles() {
    // Write styles in standard CSS
    // https://stackoverflow.com/questions/25193964/how-can-i-have-a-web-components-width-and-height-be-inherited-by-its-children
    return css`
			:host {
        display: block;  /* or display: block; */
        position: relative;
        margin: 0;
        width: 100%;
			}
		`;
  }

  attributeChangedCallback(name, _old, value) {
    super.attributeChangedCallback(name, _old, value);
    // console.log('attributeChangedCallback', name, _old, value);
    this.querySelectorAll('.stepper-2a-step').forEach((step, index) => {
      step.classList.remove('stepper-2a-step--active'); // reset
      let stepperStepIndex = index + 1;
      console.log(stepperStepIndex, parseInt(value));
      if (stepperStepIndex <= parseInt(value)) {
        step.classList.add('stepper-2a-step--active'); // set if current step 
      }
      if (stepperStepIndex === parseInt(value)) {
        step.classList.add('stepper-2a-step--current'); // set if current step 
      } else {
        step.classList.remove('stepper-2a-step--current'); // reset if not current step
      }
      // step.addEventListener('click', () => this.handleStepClick(index));
    });
  }

  handleSlotChange(event) {
    // console.log('handleSlotChange', event)
    // const childNodes = event.target.assignedNodes({ flatten: true });
    // // ... do something with childNodes ...
    // this.allText = childNodes.map((node) => {
    //     return node.textContent ? node.textContent : ''
    // }).join('');
  }

  // connectedCallback() {
  //   this.querySelectorAll('.stepper-step').forEach((step, index) => {
  //     step.addEventListener('click', () => this.handleStepClick(index));
  //   });
  // }

  // handleStepClick(index) {
  //   this.querySelectorAll('.stepper-step').forEach((step, stepIndex) => {
  //     step.classList.remove('active');

  //     if (index >= stepIndex) {
  //       step.classList.add('active');
  //     }
  //   })
  //   this.dispatchEvent(new CustomEvent("stepper-step-changed", { detail: index }));
  // }

  render() {
    return html`
            <div class="stepper-container" component-loaded>
                <slot @slotChange="${this.handleSlotChange}"></slot>
            </div>
        `;
  }
}

window.customElements.define('stepper-container', StepperContainerComponent);